import { FC } from "react";
import { ITrustboxTemplate } from "../../../interfaces/trustbox-template";
import logo from "../../../assets/images/trustfinance-logo.svg";
import Rate from "../../../components/rate";

const TrustboxTemplate2: FC<ITrustboxTemplate> = ({ company }) => {
  return (
    <a className="text-decoration-none" style={{ color: "unset" }} href={`https://www.trustfinance.com/companies/${company.id}`} target="_blank" rel="noreferrer noopener">
      <div className="overflow-hidden d-flex flex-column align-items-center">
        <div>
          <div style={{ display: 'flex', alignItems: "center" }}>
            <img src={logo} alt="" width={19} height={19} />
            <span style={{ fontSize: 11, marginLeft: 4, fontWeight: "bold" }}>TrustFinance</span>
          </div>
          <div className="mt-1">
            <Rate score={company.rate.score} size={18} />
          </div>
          <div className="mt-1">
            <div style={{ fontSize: 11 }}>TrustScore <b>{company.rate.score}</b></div>
            <div style={{ fontSize: 11 }}><b>{company.rate.totalReview}</b> reviews</div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default TrustboxTemplate2;